<script lang="ts">
import SettingsBox from '../../elements/SettingsBox.svelte';
import Title from "../../elements/settings/Title.svelte";
import TitleIcon from "../../elements/settings/TitleIcon.svelte";
import PrimaryBox from "../../elements/settings/PrimaryBox.svelte";
import Action from '../../elements/settings/Buttons/Action.svelte';
import { colorSelector, modalContent } from '../../../stores/globalState';
import IntroTutorialModal from '../../modals/IntroTutorialModal.svelte';
import { bgColors, customColors } from '../../../utils/utils';
import { accentColor } from '../../../stores/storedSettings';

    function openColorPicker(e) {
        colorSelector.set({show: true, colors: [...customColors, 'white'], x:e.pageX, y: e.pageY, callback: changeAccentColor });
        document.getElementById('change-accent-color').style.filter = 'blur(2px)';
    }

    function changeAccentColor(color: string) {
        accentColor.set(color);
        document.getElementById('change-accent-color').style.filter = null;
    }
</script>

<SettingsBox bordered={false} id="change-accent-color">
    <Title title="强调色">
        <TitleIcon noFill>
            <img src="/media/color-palette.png" alt="强调色" class="settings-title-icon w-10 md:w-14">
        </TitleIcon>
    </Title>
    <PrimaryBox 
        label={{text: '更改强调色'}} 
        description={{text:'自定义放松时钟', iconClass: 'lnr lnr-question-circle'}}
        available={true}
    >
    <div class="flex items-center">
        <span class="inline-block w-2 h-2 mr-6 rounded-full" style="background-color: {$accentColor}"></span>
        <Action label="打开" on:click={openColorPicker}/>
    </div>
    </PrimaryBox>
</SettingsBox>